import {Heading, Stack, Text} from '@chakra-ui/react'
import {ReactNode} from 'react'

interface Props {
  title: ReactNode
  description: string
}

export function NewResourceFormHeader({description, title}: Props) {
  return (
    <Stack asChild gapY="3" marginBottom="8">
      <header>
        <Heading as="h1" fontSize="2xl" fontWeight="semibold">
          {title}
        </Heading>
        <Text fontSize="sm" color="fg.muted" maxW="45rem">
          {description}
        </Text>
      </header>
    </Stack>
  )
}
